package com.eladfinish.bible.contest.network.logging

import io.github.aakira.napier.Napier
import io.ktor.client.plugins.logging.Logger

class NetworkLogger : Logger {
    override fun log(message: String) {
        Napier.d(message = message, tag = "Network logger")
    }
}
